/* Divided by Design. Calm interactions only. */
(function () {
  "use strict";

  // Reveal on scroll, once each.
  var revealables = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && revealables.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    revealables.forEach(function (el) { io.observe(el); });
  } else {
    revealables.forEach(function (el) { el.classList.add("is-in"); });
  }

  // Mobile menu.
  var toggle = document.querySelector("[data-menu-toggle]");
  var panel = document.querySelector("[data-menu-panel]");
  if (toggle && panel) {
    toggle.addEventListener("click", function () {
      var open = panel.classList.toggle("is-open");
      panel.hidden = !open;
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      toggle.textContent = open ? "Close" : "Menu";
    });
  }

  // Keep the hidden precise-variant select in step with option selects.
  var form = document.getElementById("product-form");
  if (form) {
    var optionSelects = form.querySelectorAll(".product__variant");
    var idSelect = form.querySelector(".product__variant-hidden");
    if (idSelect && optionSelects.length) {
      var sync = function () {
        var chosen = [];
        optionSelects.forEach(function (s) { chosen.push(s.value); });
        var target = chosen.join(" / ");
        Array.prototype.forEach.call(idSelect.options, function (opt) {
          if (opt.textContent.trim() === target) { idSelect.value = opt.value; }
        });
      };
      optionSelects.forEach(function (s) { s.addEventListener("change", sync); });
      sync();
    }
  }

  // Shop filter drawer: close on outside click or Escape (progressive enhancement; works without JS).
  var filterEl = document.querySelector("[data-filter]");
  if (filterEl) {
    document.addEventListener("click", function (e) {
      if (filterEl.open && !filterEl.contains(e.target)) { filterEl.open = false; }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && filterEl.open) {
        filterEl.open = false;
        var s = filterEl.querySelector("summary");
        if (s) { s.focus(); }
      }
    });
  }
})();
